import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgFor } from '@angular/common';

@Component({
  selector: 'app-tabs',
  imports: [NgClass, NgFor],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent {

  @Input() tabs?: string[];
  @Input() initialTab ?: string;
  @Input() styleClass?: string;
  @Output() emitter = new EventEmitter<string>();
  public selected?: string;

  ngOnInit(): void {
    this.selected = this.initialTab ? this.initialTab : this.tabs?.[0];
  }

  clicked(value: string) {
    this.selected = value;
    this.emitter.emit(value);
  }

}
